module.exports = [
	{
		"data": "featured",
		"title": "Featured Customer Stories",
		"customers": [
			{
				"img": "logo-schneider-electric.png",
				"text": "Schneider Electric: Streamlining Identity Management",
				"websiteUrl": "http://www.schneider-electric.com/",
				"caseStudyUrl": "https://auth0.com/learn/schneider-electric-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-jet-privilege.png",
				"text": "JetPrivilege: SSO Makes For A Seamless Travel Experience",
				"websiteUrl": "https://www.jetprivilege.com/",
				"caseStudyUrl": "https://auth0.com/learn/jetprivilege-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-safari-books.svg",
				"text": "Safari: Auth0 SSO Drives B2B Expansion",
				"websiteUrl": "https://www.safaribooksonline.com/",
				"caseStudyUrl": "https://auth0.com/learn/safari-case-study/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-harvard-medical-school.svg",
				"text": "Harvard Medical School: Identity Secures NIH Research",
				"websiteUrl": "https://undiagnosed.hms.harvard.edu/",
				"caseStudyUrl": "https://auth0.com/learn/harvard-medical-school-identity-secures-nih-research/",
				"videoURL": "//fast.wistia.net/embed/iframe/6gehzyd3w0?popover=true",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-marks-spencer.svg",
				"text": "Marks & Spencer: Auth0 Authentication Scalability In Action",
				"websiteUrl": "http://www.marksandspencer.com/",
				"caseStudyUrl": "https://auth0.com/learn/marks-spencer-auth0-authentication-scalability-in-action/",
				"color": "#f8f8f8"
			},
			{
				"img": "logo-bluetooth-sig.svg",
				"text": "Bluetooth Special Interest Group (SIG) Case Study",
				"websiteUrl": "https://www.bluetooth.com/",
				"caseStudyUrl": "https://auth0.com/learn/bluetooth-case-study/",
				"color": "#f8f8f8"
			}
		]
	},
	{
		"data": "logistics",
		"title": "Logistics",
		"customers": [
			{
				"hashName": "aeromexico",
				"img": "logo-aeromexico.svg",
				"text": "Aeromexico is Mexico's global airline. Operating more than 600 flights daily with hubs at the Mexico City International Airport and at the Monterrey International Airport.",
				"websiteUrl": "http://aeromexico.com"
			},
			{
				"img": "logo-freeformers.png",
				"text": "Freeformers helps transform some of the world's biggest companies for the digital age through exciting, hands-on workshops for everyone.",
				"websiteUrl": "https://freeformers.com/"
			},
			{
				"img": "logo-stage-3.png",
				"text": "Stage 3 Systems has supported the shipping industry with easy-to-use, secure, common-sense software solutions for their information technology needs for more than a decade.",
				"websiteUrl": "http://stage3systems.com/"
			}
		]
	},
	{
		"data": "healthcare",
		"title": "Healthcare",
		"customers": [
			{
				"img": "logo-fmi.png",
				"text": "The Friedrich Miescher Institute for Biomedical Research (FMI), based in Basel, Switzerland, is a world class center for basic research in life sciences and part of the Novartis Research Foundation.",
				"websiteUrl": "http://www.fmi.ch"
			},
			{
				"img": "logo-zyto.jpg",
				"text": "ZYTO is a global technology company that creates interfaces between the human body and digital technology to provide insights into personal health and wellness decisions.",
				"websiteUrl": "http://www.zyto.com"
			},
			{
				"img": "logo-SIB.png",
				"text": "The Swiss Institute of Bioinformatics is a world-renowned scientific consortium of research groups from both universities and the Swiss Federal Institutes of technology.",
				"websiteUrl": "http://www.isb-sib.ch"
			},
			{
				"img": "logo-bloodhub.png",
				"text": "BloodHub is a SaaS solution for the medical industry, simplifying the management of blood supplies.",
				"websiteUrl": "http://www.bloodhub.com"
			},
			{
				"img": "logo-wellintune.png",
				"text": "Wellintune is a comprehensive health management service and online platform that allows companies, individuals, and communities alike grow to be healthier.",
				"websiteUrl": "https://www.attunelife.com/"
			},
			{
				"img": "logo-kyruus.png",
				"text": "Kyruus is an enterprise healthcare provider solutions company that helps to optimize Patient Access, Referral Management, and Care Coordination operations.",
				"websiteUrl": "http://www.kyruus.com/"
			}
		]
	},
	{
		"data": "energy",
		"title": "Energy",
		"customers": [
			{
				"img": "logo-sinopec.svg",
				"text": "Sinopec Limited's parent, Sinopec Group, is one of the major State Owned petroleum energy and chemicals companies in China.",
				"websiteUrl": "http://english.sinopec.com/"
			},
			{
				"img": "logo-canem.png",
				"text": "Canem, Ltd. is a Canadian firm specializing in electrical contracting.",
				"websiteUrl": "http://www.canem.com"
			},
			{
				"img": "logo-tachyus.png",
				"text": "Tachyus creates technology to optimize energy production for the oil and gas industry.",
				"websiteUrl": "http://www.tachyus.com/"
			},
			{
				"img": "logo-agl.png",
				"text": "AGL is one of Australia's leading integrated energy companies and largest ASX listed owner, operator and developer of renewable energy generation in the country.",
				"websiteUrl": "http://www.agl.com.au"
			}
		]
	},
	{
		"data": "media",
		"title": "Media",
		"customers": [
			{
				"hashName": "PBS",
				"img": "logo-pbs.svg",
				"text": "PBS is an independently operated non-profit organization and is the most prominent provider of television programs to public television stations in the United States.",
				"websiteUrl": "http://www.pbs.org/"
			},
			{
				"hashName": "newscorp",
				"img": "logo-newscorp.svg",
				"text": "News Corp is a network of leading companies in the worlds of diversified media, news, education, and information services.",
				"websiteUrl": "http://www.newscorp.com/"
			},
			{
				"hashName": "harper",
				"img": "logo-harper.png",
				"text": "HarperCollins Publishers LLC is one of the world's largest publishing companies and is part of the 'Big Five' English-language publishing companies.",
				"websiteUrl": "http://www.harpercollins.com/"
			},
			{
				"hashName": "houghton-mifflin-harcourt",
				"img": "logo-houghton-mifflin-harcourt.png",
				"text": "Houghton Mifflin Harcourt is a global learning company dedicated to changing people’s lives by fostering passionate, curious learners.",
				"websiteUrl": "http://www.hmhco.com/"
			},
			{
				"hashName": "dow-jones",
				"img": "logo-dow-jones.png",
				"text": "Dow Jones & Company is an American publishing and financial information firm. Dow Jones has grown to be a worldwide news and information powerhouse.",
				"websiteUrl": "http://www.dowjones.com/"
			},
			{
				"img": "logo-music-memory.jpg",
				"text": "MUSIC & MEMORY℠ is a non-profit organization that brings personalized music into the lives of the elderly or infirm, vastly improving quality of life.",
				"websiteUrl": "http://musicandmemory.org/"
			},
			{
				"img": "logo-cm-group.png",
				"text": "CM Group is a leader in delivering eLearning and mobile learning to major companies worldwide. ",
				"websiteUrl": "http://www.cm-group.co.uk"
			},
			{
				"img": "logo-fubotv.png",
				"text": "fuboTV is a streaming TV service offering the best live soccer coverage 24x7. Featuring sports and entertainment programming.",
				"websiteUrl": "http://www.fubo.tv"
			},
			{
				"img": "logo-plan-3.png",
				"text": "Plan 3 consists in a diverse set of professionals creating streamlined services that leverage the latest in know-how. ",
				"websiteUrl": "http://plan3.se/"
			},
			{
				"img": "logo-medvid.png",
				"text": "medvid.io powers HIPAA Compliant Video Management and transforms the Doctor – Patient Relationship, One Video at a Time.",
				"websiteUrl": "https://reeldx.com/medvidio/"
			},
			{
				"img": "logo-infomedia.png",
				"text": "Infomedia is a worldwide leader in SaaS automotive parts and service systems which empower their dealer customers to deliver a superior service level.",
				"websiteUrl": "http://www.infomedia.com.au"
			},
			{
				"img": "logo-coleman.png",
				"text": "Coleman Insights is a firm that has has helped media properties build strong brands and develop great content since 1978.",
				"websiteUrl": "http://www.colemaninsights.com/"
			},
			{
				"img": "logo-southcomm.png",
				"text": "SouthComm is the nation’s second largest publisher of alternative weeklies. The company owns more than 30 titles targeting B2B and audiences around the country.",
				"websiteUrl": "http://www.southcomm.com/"
			},
			{
				"img": "logo-kinesis.png",
				"text": "Kinesis provides pragmatic and evidence based solutions to the climate problem. , It’s mission is to make organizations and cities more resilient, productive and sustainable.",
				"websiteUrl": "http://www.kinesis.org/"
			}
		]
	},
	{
		"data": "financial",
		"title": "Financial Services",
		"customers": [
			{
				"hashName": "financial-times",
				"img": "logo-financial-times.svg",
				"text": "The Financial Times is one of the world’s leading business news organisations, recognised internationally for its authority, integrity and accuracy.",
				"websiteUrl": "https://www.ft.com/"
			},
			{
				"hashName": "berkshire",
				"img": "logo-bhtp.png",
				"text": "As Berkshire Hathaway’s travel insurance arm, BHTP gives travelers the coverage they need in simpler and smarter ways than ever before.",
				"websiteUrl": "https://www.bhtp.com/"
			},
			{
				"img": "logo-sancor.png",
				"text": "Grupo Sancor Seguros is the premier Insurance Group in Argentina and a market leader across Latin America.",
				"websiteUrl": "https://www.gruposancorseguros.com/en"
			},
			{
				"img": "logo-concierge-auctions.png",
				"text": "Concierge Auctions is an innovative, online luxury real-estate auction house. A win-win for sellers, buyers, and agents alike.",
				"websiteUrl": "http://www.conciergeauctions.com"
			},
			{
				"img": "logo-advance.png",
				"text": "AdvancedREI is Deal Intelligence for Commercial Real Estate. It delivers advanced predictive analysis and insights to today's commercial real estate professionals.",
				"websiteUrl": "http://advancedrei.com/"
			},
			{
				"img": "logo-notient.png",
				"text": "Notient automates and aggregates peer-to-peer investments. Their system allows the novice or hands-off investor to be up and running with Notient in only a few clicks.",
				"websiteUrl": "https://notient.com/#!/aboutus"
			},
			{
				"img": "logo-simpology.png",
				"text": "Simpology is an Australia-based software company delivering powerful solutions for originating and processing loan applications.",
				"websiteUrl": "http://www.simpology.com.au"
			},
			{
				"img": "logo-nickel-swan.svg",
				"text": "Nickel & Swan offers a revolutionary equity option analytics platform to help optimize option trades, understand option data, and feel the market pulse.",
				"websiteUrl": "http://www.nickelandswan.com/"
			},
			{
				"img": "logo-spv.jpg",
				"text": "Sparebanken Vest, established in 1823, is Norway's third largest bank, and a financial services leader in Western Norway. With a focus on both private and corporate banking, Sparebanken Vest is committed to Norway's social and commercial development.",
				"websiteUrl": "https://www.spv.no/"
			}
		]
	},
	{
		"data": "retail",
		"title": "Retail",
		"customers": [
			{
				"hashName": "nandos",
				"img": "logo-nandos.svg",
				"text": "Nando's is an international casual dining restaurant chain originating from South Africa, with a Mozambican/Portuguese theme. Founded in 1987, Nando's operates about 1,000 outlets in 30 countries.",
				"websiteUrl": "http://www.nandos.com/"
			},
			{
				"img": "logo-russell-cellular.jpg",
				"text": "Russell Cellular is a Verizon Premium Retailer operating in the midwest and southern USA. Founded in 1993, Russell Cellular has over 250 retail locations in 22 states.",
				"websiteUrl": "http://www.russellcellular.com"
			},
			{
				"img": "logo-collect.png",
				"text": "Collect.it is a social community and marketplace serving the multi-billion dollar collectibles market.",
				"websiteUrl": "http://collect.it/"
			},
			{
				"img": "logo-redicarpet.png",
				"text": "Redi Carpet is one of the largest flooring suppliers to the apartment industry. The company offers next day flooring installation for multi-family apartments and homes.",
				"websiteUrl": "http://www.redicarpet.com/"
			},
			{
				"img": "logo-krrb.jpg",
				"text": "Krrb is a local classifieds, connecting your community with other communities around the world.",
				"websiteUrl": "https://krrb.com/"
			},
			{
				"img": "logo-directlease.png",
				"text": "DirectLease group is an online car lease company for Dutch, Belgian and German customers.",
				"websiteUrl": "http://directlease.nl/DLNl/home.do"
			},
			{
				"img": "logo-casestack.png",
				"text": "CaseStack is a leading logistics provider that specializes in applying efficient and sustainable supply chain solutions, including warehousing and transportation.",
				"websiteUrl": "https://ww2.casestack.com/"
			},
			{
				"img": "logo-foodjunky.png",
				"text": "Foodjunky is an online platform for ordering food. It makes the process easy for individuals, groups, and catering, so everyone's happy.",
				"websiteUrl": "http://www.foodjunky.com/"
			},
			{
				"img": "logo-clowder.svg",
				"text": "Clowder is premium coffee brewed and delivered to customers door within 15 minutes. Offices in NYC and Mountain View.",
				"websiteUrl": "https://www.clowder.nyc/"
			}
		]
	},
	{
		"data": "manufacturing",
		"title": "Manufacturing",
		"customers": [
			{
				"hashName": "polaris",
				"img": "logo-polaris-industries.svg",
				"text": "Polaris Industries is a global leader in the off-road consumer and millitary markets.",
				"websiteUrl": "http://www.polaris.com"
			},
			{
				"img": "logo-coop-tender.png",
				"text": "Coop Tender ™ Internet Wi-Fi Enabled Automatic Chicken Coop Door takes the hassles out of raising free-range chickens.",
				"websiteUrl": "http://cooptender.com/"
			}
		]
	},
	{
		"data": "software",
		"title": "Software / Design",
		"customers": [
			{
				"hashName": "atlassian",
				"img": "logo-atlassian.svg",
				"text": "Atlassian is a group of enterprise software companies that develops products for software developers, project managers, and content management.",
				"websiteUrl": "https://www.atlassian.com/"
			},
			{
				"hashName": "mozilla",
				"img": "logo-mozilla.svg",
				"text": "Mozilla is a technology not-for-profit dedicated to ensuring the Internet is a global public resource, open and accessible to all.  We do that by building products, technologies and programs that put people in control of their online lives.",
				"websiteUrl": "https://www.mozilla.org"
			},
			{
				"hashName": "nvidia",
				"img": "logo-nvidia.svg",
				"text": "NVIDIA is the world leader in visual computing. The GPU, their invention, serves as the visual cortex of modern computers and is at the heart of their products and services.",
				"websiteUrl": "https://www.nvidia.com/"
			},
			{
				"hashName": "bluetooth-sig",
				"img": "logo-bluetooth-sig.svg",
				"text": "The Bluetooth SIG is the body that oversees the development of Bluetooth standards and the licensing of the Bluetooth technologies and trademarks to manufacturers.",
				"websiteUrl": "http://www.bluetooth.com/"
			},
			{
				"img": "logo-redsequence.png",
				"text": "Red Sequence was founded in 2013, in order to develop cloud productivity apps for individuals and teams. It’s currently extending its application, Timestamp.",
				"websiteUrl": "http://www.redsequence.com/"
			},
			{
				"img": "logo-zudio.png",
				"text": "With Zudio, you can manage your Windows Azure Storage wherever you are, on any device with a modern web browser, no artificial licence restrictions.",
				"websiteUrl": "https://zud.io/"
			},
			{
				"img": "logo-giant-machines.png",
				"text": "Giant Machines authors custom software for companies large and small by providing consulting services to fit their customer’s needs.",
				"websiteUrl": "http://giantmachines.com/"
			},
			{
				"img": "logo-fadeit.svg",
				"text": "Fadeit is a software development company with expertise in a wide variety of IT subjects such as Internet of Things, Distributed Systems, Open Data, and more.",
				"websiteUrl": "http://fadeit.dk/da"
			},
			{
				"img": "logo-performant.png",
				"text": "Performant Software Solutions partners with researchers, scholars and entrepreneurs to create web and mobile software that educates, enriches and entertains.",
				"websiteUrl": "http://www.performantsoftware.com/"
			},
			{
				"img": "logo-contemplor.png",
				"text": "Contemplor Software has developed modeling and work product automation tools that revolutionize business.",
				"websiteUrl": "http://contemplorsoftware.com/"
			},
			{
				"img": "logo-dragonfly.png",
				"text": "Dragonfly Design Group provides graphic design and various services for PR firms, marketing consultants, entrepreneurs and even in-house art departments.",
				"websiteUrl": "http://dragonflydg.com/"
			},
			{
				"img": "logo-identillect.png",
				"text": "Identillect Technologies is an innovative email security company with a proprietary email encryption technology targeted at organizations, as well as individuals.",
				"websiteUrl": "https://identillect.com/"
			},
			{
				"img": "logo-kiosk-browser.png",
				"text": "Kiosk Browser has been designed for use on any android device and is great for creating public kiosks, interactive digital signage etc.",
				"websiteUrl": "http://www.android-kiosk.com/"
			},
			{
				"img": "logo-trueflow.png",
				"text": "TrueFlow is changing the way venues engage with users indoors using sensors, wifi and other radio signals within the venue, resulting in greater engagement.",
				"websiteUrl": "http://www.trueflow.io/"
			},
			{
				"img": "logo-stonetip.png",
				"text": "Stonetip specializes in mobile app development, with apps that are aimed at mapping, productivity and fitness.",
				"websiteUrl": "http://code.stonetip.com/about/"
			},
			{
				"img": "logo-mindjet.png",
				"text": "Mindjet is a collaborative work management software Mindjet's software products, are designed to visually and collaboratively manage information and tasks.",
				"websiteUrl": "https://www.mindjet.com"
			},
			{
				"img": "logo-trading-work.png",
				"text": "TradingWorks ensure their customers understand how their resources are being utilized and provide real time data to help them to maximize efficiency and results.",
				"websiteUrl": "http://www.tradingworks.com.br/"
			},
			{
				"img": "logo-sapho.png",
				"text": "Sapho provides an enterprise software platform for organizations to offer access to corporate information on mobile devices by utilizing software APIs.",
				"websiteUrl": "http://www.sapho.com/"
			},
			{
				"img": "logo-gridvision.png",
				"text": "GridVision transforms IT by automating and eliminating repetitive, mundane and complex activities such as monitoring computer systems and applications.",
				"websiteUrl": "http://www.grid-vision.com/"
			},
			{
				"img": "logo-agrippa.png",
				"text": "Agrippa Solutions provides services for project management, change management, enterprise architecture, quality assurance and other facets of IT.",
				"websiteUrl": "https://agrippa.azurewebsites.net/"
			},
			{
				"img": "logo-blinkmobile.jpg",
				"text": "BlinkMobile helps organizations more easily harness mobile and emerging technologies to quickly and securely extend their core business systems.",
				"websiteUrl": "http://blinkmobile.com.au/"
			},
			{
				"img": "logo-candoris.png",
				"text": "Candoris is an IT Systems Integration firm focused on implementing technology that increases the efficiency of businesses.",
				"websiteUrl": "http://www.candoris.com/"
			},
			{
				"img": "logo-timestamp.png",
				"text": "Timestamp is a time tracking application that will help you discover in what you consume your time.",
				"websiteUrl": "http://www.timestamphq.com/"
			},
			{
				"hashName": "amd",
				"img": "logo-amd.svg",
				"text": "Advanced Micro Devices, Inc. (AMD) is an American multinational semiconductor company based in Sunnyvale, California, United States, that develops computer processors and related technologies for business and consumer markets.",
				"websiteUrl": "http://www.amd.com/"
			}
		]
	},
	{
		"data": "online-services",
		"title": "Online Services / Analytics",
		"customers": [
			{
				"hashName": "optimizely",
				"img": "logo-optimizely.svg",
				"text": "Optimizely is the world’s leading experimentation platform, enabling businesses to deliver continuous experimentation and personalization across websites, mobile apps and connected devices.",
				"websiteUrl": "https://www.optimizely.com"
			},
			{
				"img": "logo-purestorage.svg",
				"text": "Pure Storage is an all-flash enterprise storage company that delivers high performance solutions for data centers, cloud computing, Big Data and real-time analytics.",
				"websiteUrl": "http://www.purestorage.com/"
			},
			{
				"img": "logo-cymbalstream.png",
				"text": "Cymbalstream delivers what others only talk about – rapid ROI, effective optimization and tools to manage your IT without the typical administrative overhead and cost.",
				"websiteUrl": "http://www.cymbalstream.com/"
			},
			{
				"img": "logo-blueip.jpg",
				"text": "BluIP is a leading wholesale provider of cloud-based voice technology. They deliver mission-critical products engineered for the SMB and LE Markets.",
				"websiteUrl": "http://www.bluip.com/"
			},
			{
				"img": "logo-ire.png",
				"text": "Ireckon uses their expertise to create powerful software solutions that solve business needs, on time and on budget. ",
				"websiteUrl": "http://www.ireckon.nl/"
			},
			{
				"img": "logo-10th-magnitude.svg",
				"text": "10th Magnitude, one of the top Microsoft Azure services firms in the US, provides customers with a full suite of cloud services.",
				"websiteUrl": "http://www.10thmagnitude.com/"
			},
			{
				"img": "logo-bang-the-table.jpg",
				"text": "Bang the Table delivers world-class interactive communications solutions branded with their client's identity.",
				"websiteUrl": "http://www.bangthetable.com/"
			},
			{
				"img": "logo-my-objectives.png",
				"text": "MyObjectives is performance management solution that is a low cost, SaaS solution that allows organizations of all sizes to implement Management by Gaming.",
				"websiteUrl": "http://www.allianceenterprises.com/myobjectives"
			},
			{
				"img": "logo-westat.png",
				"text": "Westat, Inc. specializes in executing non-partisan, scientifically valid research studies for a broad range of  organizations.",
				"websiteUrl": "http://www.westat.com/"
			},
			{
				"img": "logo-rapidminer.png",
				"text": "RapidMiner is an open source, predictive analytics platform that lets analysts quickly uncover opportunities and risks, and guide business decision.",
				"websiteUrl": "http://www.rapidminer.com/"
			},
			{
				"img": "logo-moving.png",
				"text": "Machine to Machine (M2M) Services. Data Mining and Business Intelligence. Ericsson Authorised Service Partner.",
				"websiteUrl": "http://movingdata.com"
			},
			{
				"img": "logo-peruse.png",
				"text": "Peruse.io is pioneering a new way to get answers to questions about your documents.",
				"websiteUrl": "https://peruse.io/"
			},
			{
				"img": "logo-datastreamx.svg",
				"text": "DataStreamX is a data marketplace for real-time data created from IoT, M2M and Big Data Applications.",
				"websiteUrl": "https://www.datastreamx.com/"
			},
			{
				"img": "logo-42.png",
				"text": "42 is a predictive analytics platform for retailers. 42 works with some of the world's best known brands and is backed by Y Combinator.",
				"websiteUrl": "https://42technologies.com/#/"
			},
			{
				"img": "logo-satalyst.png",
				"text": "Satalyst is focused on delivering high quality project based IT solutions and assists companies to realise the business benefits technology can offer.",
				"websiteUrl": "https://www.clowder.nyc/"
			},
			{
				"img": "logo-salt.svg",
				"text": "Salt provides a services that help customers build powerful datasets. They focus on turning big data into small data that is accessible, understandable, and actionable.",
				"websiteUrl": "http://salt.io/"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/customers/customers.json
// module id = 1116
// module chunks = 0